import type { Params } from '@vaadin/router';
import { Router } from '@vaadin/router';

export enum BlogRoutes {
  HOME = 'home',
  POST = 'post',
  SEARCH = 'search',
  CATEGORY = 'category',
  TAG = 'tag',
  DRAFT = 'draft',
}

export function getRouter(): Router {
  return (window as any)['sy-app-router'];
}

export function urlFor(name: BlogRoutes, params?: Params): string {
  let path: string;
  try {
    path = getRouter().urlForName(name, params);
  } catch (error) {
    console.warn(error.message);
    path = getRouter().urlForName(BlogRoutes.HOME);
  }

  return removeBaseUrl(path);
}

export function go(name: BlogRoutes, params?: Params): boolean {
  const path = urlFor(name, params);
  return goToPath(path);
}

export function goToPath(path: string): boolean {
  return Router.go(path);
}

function removeBaseUrl(path: string): string {
  return path.replace(getRouter().baseUrl, '');
}
